import { useCallback, useEffect, useState } from 'react';

type DropdownPosition = 'top' | 'bottom';

export const useDropdownPosition = (
    containerRef: React.RefObject<HTMLElement>,
    dropdownRef: React.RefObject<HTMLElement>,
    isOpen: boolean,
    containerBlockId: string
) => {
    const [dropdownPosition, setDropdownPosition] =
        useState<DropdownPosition>('bottom');

    const updateDropdownPosition = useCallback(() => {
        if (!containerRef.current || !dropdownRef.current) return;

        const containerRect = containerRef.current.getBoundingClientRect();
        const dropdownRect = dropdownRef.current.getBoundingClientRect();
        const containerElement = document.getElementById(containerBlockId);

        if (!containerElement) return;

        const containerBottom = containerElement.getBoundingClientRect().bottom;
        const spaceBelow = containerBottom - containerRect.bottom;

        if (
            spaceBelow < dropdownRect.height &&
            containerRect.top > dropdownRect.height
        ) {
            setDropdownPosition('top');
        } else {
            setDropdownPosition('bottom');
        }
    }, [containerRef, dropdownRef, containerBlockId]);

    useEffect(() => {
        if (isOpen) {
            updateDropdownPosition();
            window.addEventListener('scroll', updateDropdownPosition);
            window.addEventListener('resize', updateDropdownPosition);
        }

        return () => {
            window.removeEventListener('scroll', updateDropdownPosition);
            window.removeEventListener('resize', updateDropdownPosition);
        };
    }, [isOpen, updateDropdownPosition]);

    return dropdownPosition;
};
